import { Injectable } from '@angular/core';
import { CaseManager } from './case-data.service';

@Injectable()
export class SupportCaseOrchestratorService {
    numOfOpenCases: number;

    constructor(private caseManager: CaseManager) {
        this.numOfOpenCases = 0;
        //use the casesData.getCaseCounts here to directly fetch the case count from server
        //instead of relying on the support_nav.component to be instantiated.
        this.caseManager.getCaseCounts().subscribe(countData => {
            this.numOfOpenCases = countData.total;
        });
    }
}
